import { FundingSource, FundingSourceDto, IResponsePaginateRaw, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseQueryParams, IResponse } from '@/types/generic-responses.types';

@Injectable({
  providedIn: 'root',
})
export class FundingSourceService {
  BASEURL = `${environment.api.paramsUrl}/source-financement`;
  httpClient = inject(HttpClient);

  getFundingSources(params?: BaseQueryParams): Observable<IResponsePaginateRaw<FundingSource>> {
    return this.httpClient.get<IResponsePaginateRaw<FundingSource>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getAll(params?: BaseQueryParams): Observable<IResponse<FundingSource>> {
    return this.httpClient.get<IResponse<FundingSource>>(`${this.BASEURL}/list`, { params: params as HttpParams });
  }

  getOne(id: number): Observable<WithMetadata<FundingSource>> {
    return this.httpClient.get<WithMetadata<FundingSource>>(`${this.BASEURL}/${id}`);
  }

  add(fundingSource: FundingSourceDto): Observable<WithMetadata<FundingSource>> {
    return this.httpClient.post<WithMetadata<FundingSource>>(`${this.BASEURL}`, fundingSource);
  }

  update(id: number, fundingSource: FundingSourceDto): Observable<WithMetadata<FundingSource>> {
    return this.httpClient.put<WithMetadata<FundingSource>>(`${this.BASEURL}/${id}`, fundingSource);
  }

  delete(id: number): Observable<WithMetadata<FundingSource>> {
    return this.httpClient.delete<WithMetadata<FundingSource>>(`${this.BASEURL}/${id}`);
  }
}
